import React from 'react';
import './trabajadores.css';

const Trabajadores = () => {
  const trabajadores = [
    {
      id: 1,
      nombre: "María González",
      cargo: "Directora General",
      imagen: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
      descripcion: "Con más de 15 años de experiencia en el sector, María lidera nuestro equipo con pasión y dedicación."
    },
    {
      id: 2,
      nombre: "Carlos Rodríguez",
      cargo: "Jefe de Operaciones",
      imagen: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
      descripcion: "Especialista en optimización de procesos y gestión de equipos de alto rendimiento."
    },
    {
      id: 3,
      nombre: "Ana Martínez",
      cargo: "Coordinadora de Proyectos",
      imagen: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
      descripcion: "Experta en gestión de proyectos y relaciones con clientes, asegurando la excelencia en cada entrega."
    },
    {
      id: 4,
      nombre: "Luis Pérez",
      cargo: "Especialista Técnico",
      imagen: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
      descripcion: "Profesional con amplia experiencia en soluciones técnicas y atención al cliente."
    }
  ];

  return (
    <div className="trabajadores-container">
      <div className="trabajadores-header">
        <h2>Nuestro Equipo</h2>
        <p>Conoce a los profesionales que hacen posible nuestro éxito</p>
      </div>
      
      <div className="trabajadores-grid">
        {trabajadores.map((trabajador) => (
          <div key={trabajador.id} className="trabajador-card">
            <div className="trabajador-imagen-container">
              <img 
                src={trabajador.imagen} 
                alt={trabajador.nombre}
                className="trabajador-imagen"
              />
            </div>
            <div className="trabajador-info">
              <h3>{trabajador.nombre}</h3>
              <span className="trabajador-cargo">{trabajador.cargo}</span>
              <p className="trabajador-descripcion">{trabajador.descripcion}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Trabajadores;
